export const PendoFeature = Object.freeze({
  TimeBucketingApply: 'time_bucketing_apply',
  WidgetTypeIconButton: 'widget_type_icon_button',
  TableWidgetShowTop: 'table_widget_show_top',
  PolicyCreationDocs: 'policy-creation-docs',
});

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PendoFeature = (typeof PendoFeature)[keyof typeof PendoFeature];
